import { combineReducers } from 'redux';
import {
  GET_MAIN_PAGE_BUTTONS_STARTED,
  GET_MAIN_PAGE_BUTTONS_SUCCESS,
  GET_MAIN_PAGE_BUTTONS_FAILURE,
  GET_ALL_CONTENTS_FOR_EXPORT_STARTED,
  GET_ALL_CONTENTS_FOR_EXPORT_SUCCESS,
  GET_ALL_CONTENTS_FOR_EXPORT_FAILURE,
  RESET_CONTENTS_FOR_EXPORT,
  SEND_CONTENTS_FOR_IMPORT_STARTED,
  SEND_CONTENTS_FOR_IMPORT_SUCCESS,
  SEND_CONTENTS_FOR_IMPORT_FAILURE,
  GET_HELP_CONTENT_STARTED,
  GET_HELP_CONTENT_SUCCESS,
  GET_HELP_CONTENT_FAILURE,
  CREATE_HELP_CONTENT_STARTED,
  CREATE_HELP_CONTENT_SUCCESS,
  CREATE_HELP_CONTENT_FAILURE,
  UPDATE_HELP_CONTENT_STARTED,
  UPDATE_HELP_CONTENT_SUCCESS,
  UPDATE_HELP_CONTENT_FAILURE,
  DELETE_HELP_CONTENT_STARTED,
  DELETE_HELP_CONTENT_SUCCESS,
  DELETE_HELP_CONTENT_FAILURE,
  CLEAR_HELP_CONTENT,
} from './types';

import searchDocsReducer from '../../helpMenu/subsections/searchDocs/store/reducer';
import releaseNotesReducer from '../../helpMenu/subsections/releaseNotes/store/reducer';

import initialState from './initialState';

function pageHelpReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MAIN_PAGE_BUTTONS_STARTED:
      return {
        ...state,
        helpLoading: true,
      };
    case GET_MAIN_PAGE_BUTTONS_SUCCESS:
      return {
        ...state,
        helpLoading: false,
        helpContents: action.mainPageButtons,
      };
    case GET_MAIN_PAGE_BUTTONS_FAILURE:
      return {
        ...state,
        helpLoading: false,
      };
    case GET_ALL_CONTENTS_FOR_EXPORT_STARTED:
      return {
        ...state,
        helpContentsForExportLoading: true,
      };
    case GET_ALL_CONTENTS_FOR_EXPORT_SUCCESS:
      return {
        ...state,
        helpContentsForExportLoading: false,
        helpContentsForExport: action.helpContents,
      };
    case GET_ALL_CONTENTS_FOR_EXPORT_FAILURE:
      return {
        ...state,
        helpContentsForExportLoading: false,
      };
    case RESET_CONTENTS_FOR_EXPORT:
      return {
        ...state,
        helpContentsForExport: [],
      };
    case SEND_CONTENTS_FOR_IMPORT_STARTED:
      return {
        ...state,
        sendingContentsForImport: true,
      };
    case SEND_CONTENTS_FOR_IMPORT_SUCCESS:
      return {
        ...state,
        sendingContentsForImport: false,
      };
    case SEND_CONTENTS_FOR_IMPORT_FAILURE:
      return {
        ...state,
        sendingContentsForImport: false,
      };
    case GET_HELP_CONTENT_STARTED:
      return {
        ...state,
        helpLoading: true,
        helpContent: null,
      };
    case GET_HELP_CONTENT_SUCCESS:
      return {
        ...state,
        helpLoading: false,
        helpContent: action.helpContent,
      };
    case GET_HELP_CONTENT_FAILURE:
      return {
        ...state,
        helpLoading: false,
      };
    case CREATE_HELP_CONTENT_STARTED:
      return {
        ...state,
        helpAdding: true,
      };
    case CREATE_HELP_CONTENT_SUCCESS:
      return {
        ...state,
        helpAdding: false,
      };
    case CREATE_HELP_CONTENT_FAILURE:
      return {
        ...state,
        helpAdding: false,
      };
    case UPDATE_HELP_CONTENT_STARTED:
      return {
        ...state,
        helpUpdating: true,
      };
    case UPDATE_HELP_CONTENT_SUCCESS:
    case UPDATE_HELP_CONTENT_FAILURE:
      return {
        ...state,
        helpUpdating: false,
      };
    case DELETE_HELP_CONTENT_STARTED:
      return {
        ...state,
        contentDeleting: action.contentId,
      };
    case DELETE_HELP_CONTENT_SUCCESS:
    case DELETE_HELP_CONTENT_FAILURE:
      return {
        ...state,
        contentDeleting: false,
      };
    case CLEAR_HELP_CONTENT:
      return {
        ...state,
        helpContent: null,
      };
    default:
      return state;
  }
}

export default combineReducers({
  pageHelp: pageHelpReducer,
  searchDocs: searchDocsReducer,
  releaseNotes: releaseNotesReducer,
});
